var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @desc coord
 */
import { Group } from '../../element';
import { getRegisteredComponent } from '../index';
import { Axis } from '../axis';
import { coordType } from '../../coord';
import Grid from '../grid';
import PolarModel from '../polar';
import Geo from '../geo';
import { ComponentModel, renderModel } from '../../model';
/**
 * coord export
 */
var CoordinateModel = /** @class */ (function (_super) {
    __extends(CoordinateModel, _super);
    function CoordinateModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'coord';
        _this.polars = [];
        _this.geo = null;
        _this.grids = [];
        _this._coordinateSystems = {};
        return _this;
    }
    Object.defineProperty(CoordinateModel.prototype, "grid", {
        get: function () {
            return this.grids[0];
        },
        enumerable: true,
        configurable: true
    });
    CoordinateModel.prototype.getCordinateSystem = function (type) {
        return this._coordinateSystems[type];
    };
    CoordinateModel.prevProcessOption = function (option) {
        Axis.prevProcessOption(option);
        Grid.prevProcessOption(option);
        PolarModel.prevProcessOption(option);
    };
    CoordinateModel.prototype.getDefaultOption = function () {
        return undefined;
    };
    CoordinateModel.prototype.init = function () {
        var _this = this;
        var chartOption = this.chart.getOption();
        var _a = this.chart.getOption(), gridOption = _a.grid, polarOptions = _a.polar;
        this.grids = gridOption.map(function (gridItemOption, gridIndex) {
            return new Grid('grid', gridItemOption, _this.chart, { gridIndex: gridIndex }, _this);
        });
        this.polars = polarOptions.map(function (polarOption, polarIndex) {
            return new PolarModel('polar', polarOption, _this.chart, { polarIndex: polarIndex }, _this);
        });
        chartOption.polar = this.polars.map(function (polar) { return polar.getOption(); });
        chartOption.grid = this.grids.map(function (grid) { return grid.getOption(); });
        this.polars.forEach(function (polar) { return polar.init(); });
        this.grids.forEach(function (grid) { return grid.init(); });
        if (this.hasCordinateSeries('geo')) {
            this.geo = new Geo('geo', chartOption.geo, this.chart, null, this);
            chartOption.geo = this.geo.getOption();
            this.geo.init();
        }
        if (this.hasCordinateSeries(coordType.CALENDAR)) {
            var Coordinate = getRegisteredComponent(coordType.CALENDAR);
            this._coordinateSystems[coordType.CALENDAR] = new Coordinate(coordType.CALENDAR, chartOption.calendar, this.chart, null, this);
        }
        if (this.hasCordinateSeries(coordType.AMAP)) {
            var Coordinate = getRegisteredComponent(coordType.AMAP);
            var amap = new Coordinate(coordType.AMAP, chartOption.amap, this.chart, null, this);
            this._coordinateSystems[coordType.AMAP] = amap;
            chartOption.amap = amap.getOption();
        }
        this._eachRegisteredCoord(function (model) { return model.init(); });
    };
    CoordinateModel.prototype.hasCordinateSeries = function (type) {
        return this.chart
            .getOption()
            .series.some(function (seriesOption) {
            return seriesOption.coord === type ||
                (type === 'geo' && seriesOption.type === 'map' && seriesOption.coord !== 'amap');
        });
    };
    CoordinateModel.prototype.getAxis = function (axis, axisIndex) {
        var ret;
        this.grids.forEach(function (grid) {
            var axisList = axis === 'x' ? grid.xAxis : grid.yAxis;
            for (var i = 0; i < axisList.length; i++) {
                if (axisList[i].extraInfo.index === axisIndex) {
                    ret = axisList[i];
                }
            }
        });
        return ret;
    };
    CoordinateModel.prototype.getCoordinate = function (seriesOption) {
        var coord = seriesOption.coord, polarIndex = seriesOption.polar, xAxisIndex = seriesOption.xAxis;
        if (coord === 'cartesian2d') {
            var girdIndex = this.chart.getOption().xAxis[xAxisIndex].grid;
            return this.grids[girdIndex].getCoordinate(seriesOption);
        }
        if (coord === 'polar') {
            return this.polars[polarIndex].getCoordinate();
        }
        if (coord === 'geo') {
            return this.geo.getCoordinate();
        }
        return this._coordinateSystems[coord].getCoordinate();
    };
    CoordinateModel.prototype.getCoordClipPath = function (seriesOption, offset) {
        if (offset === void 0) { offset = 0; }
        var coordinateSystem = seriesOption.coord, polarIndex = seriesOption.polar, xAxisIndex = seriesOption.xAxis;
        if (coordinateSystem === 'cartesian2d') {
            var girdIndex = this.chart.getOption().xAxis[xAxisIndex].grid;
            return this.grids[girdIndex].getClipPath(offset);
        }
        if (coordinateSystem === 'polar') {
            return this.polars[polarIndex].getClipPath();
        }
    };
    CoordinateModel.prototype.updated = function () {
        this._destroyCoords();
        this.init();
    };
    CoordinateModel.prototype.beforeRender = function () {
        this.polars.forEach(function (polar) { return polar.beforeRender(); });
        this.grids.forEach(function (grid) { return grid.beforeRender(); });
        if (this.geo) {
            this.geo.beforeRender();
        }
        this._eachRegisteredCoord(function (coord) {
            coord.beforeRender();
        });
    };
    CoordinateModel.prototype.afterRender = function () {
        this.polars.forEach(function (polar) { return polar.afterRender(); });
        this.grids.forEach(function (grid) { return grid.afterRender(); });
        if (this.geo) {
            this.geo.afterRender();
        }
        this._eachRegisteredCoord(function (coord) {
            coord.afterRender();
        });
    };
    CoordinateModel.prototype.render = function () {
        var group = new Group({
            key: this.getKey('coord'),
        });
        this.grids.forEach(function (grid) { return group.add(renderModel(grid)); });
        this.polars.forEach(function (polar) { return group.add(renderModel(polar)); });
        if (this.geo) {
            group.add(renderModel(this.geo));
        }
        this._eachRegisteredCoord(function (coord) {
            group.add(renderModel(coord));
        });
        return group;
    };
    CoordinateModel.prototype.beforeDestroy = function () {
        this._destroyCoords();
    };
    CoordinateModel.prototype._destroyCoords = function () {
        var _this = this;
        this.grids.forEach(function (grid) { return grid.destroy(); });
        this.polars.forEach(function (polar) { return polar.destroy(); });
        if (this.geo) {
            this.geo.destroy();
        }
        if (this._coordinateSystems[coordType.CALENDAR]) {
            this._coordinateSystems[coordType.CALENDAR].destroy();
        }
        this.geo = null;
        this._eachRegisteredCoord(function (coord, key) {
            coord.destroy();
            delete _this._coordinateSystems[key];
        });
    };
    CoordinateModel.prototype._eachRegisteredCoord = function (callback) {
        for (var key in this._coordinateSystems) {
            callback(this._coordinateSystems[key], key);
        }
    };
    CoordinateModel.dependencies = ['slider'];
    return CoordinateModel;
}(ComponentModel));
export default CoordinateModel;
